import React, { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import { useModalContext } from '@bcraft-frontend-lib/core'

export const RedirectToDeposit = () => {
  const history = useHistory()

  const { pushNewModal } = useModalContext()

  const redirectToModal = useCallback(() => {
    history.push(ROUTE_URLS.MAIN())
    pushNewModal(MODAL_ROUTE_URLS.DEPOSIT())()
  }, [history, pushNewModal])

  useEffect(() => {
    redirectToModal()
  }, [redirectToModal])

  return null
}
